"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTelemetryTimer = exports.sendTelemetryCounter = void 0;
var _sendTimer = require("../repositories/browser-telemetry/v1/send-timer");
var _sendIncrement = require("../repositories/browser-telemetry/v1/send-increment");
const sendTelemetryTimer = _ref => {
  let {
    httpApi,
    key,
    value
  } = _ref;
  try {
    (0, _sendTimer.fetchSendTimer)({
      httpApi,
      parameters: {
        key,
        value
      }
    });
    /* istanbul ignore next */
  } catch (e) {
    // Ничего не логируем
  }
};
exports.sendTelemetryTimer = sendTelemetryTimer;
const sendTelemetryCounter = _ref2 => {
  let {
    httpApi,
    key,
    value
  } = _ref2;
  try {
    (0, _sendIncrement.fetchSendIncrement)({
      httpApi,
      parameters: {
        key,
        value
      }
    });
    /* istanbul ignore next */
  } catch (e) {
    // Ничего не логируем
  }
};
exports.sendTelemetryCounter = sendTelemetryCounter;